import CommonButton from '../../../components/CommonButton';
import TextField from '../../../components/TextField/TextField';

interface IAvailableAppointmentsMenuStaticProps {
  nextAvailableAppointment: string;
  setEditingAvailableAppointments: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  thisMonthYear: string;
}

function AvailableAppointmentsMenuStatic({
  nextAvailableAppointment,
  setEditingAvailableAppointments,
  thisMonthYear,
}: IAvailableAppointmentsMenuStaticProps) {
  return (
    <div className="flex flex-col items-end gap-4">
      <TextField
        label={`${thisMonthYear}: Next Available Appointment`}
        text={
          nextAvailableAppointment || 'Please enter next available appointment'
        }
        disabled
        className="w-full"
      />
      <div title="Edit next available appointment">
        <CommonButton
          text="Edit"
          variant="filled"
          className="px-4 py-2 text-sm w-fit h-fit"
          onClick={() => setEditingAvailableAppointments(true)}
        />
      </div>
    </div>
  );
}

export default AvailableAppointmentsMenuStatic;
